const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// Email validation
export const isEmail = (text) => {
  return emailRegex.test(text);
};

// Phone validation
export const isPhone = (text) => {
  const phoneRegex = /^[0-9]{10}$/;
  return phoneRegex.test(text);
};

// URL validation
export const isUrl = (text) => {
  try {
    // Use URL constructor to validate the URL
    new URL(text);
    return true;
  } catch (error) {
    // If URL constructor throws an error, it's not a valid URL
    return false;
  }
};


// Function to check if URL starts with http or https
export const isValidHttpUrl = (string) => {
  try {
    const url = new URL(string);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch (error) {
    return false;
  }
};
